import React, { useState } from "react";
import {
  Button,
  Checkbox,
  Tabs as AntdTabs,
  TabsProps as AntdTabsProps,
} from "antd";
import styles from "./Tabs.module.scss";
import cn from "classnames";

const CheckboxGroup = Checkbox.Group;

const OperationsSlot: Record<PositionType, React.ReactNode> = {
  left: <Button className="tabs-extra-demo-button">Left Extra Action</Button>,
  right: <Button>Right Extra Action</Button>,
};

type PositionType = "left" | "right";

const items = new Array(3).fill(null).map((_, i) => {
  const id = String(i + 1);
  return {
    label: `Tab ${id}`,
    key: id,
    children: `${id}`,
  };
});

type TabsProps = AntdTabsProps & {
  variant?: "primary" | "secondary";
};

const Tabs: React.FC<TabsProps> = ({
  items,
  className,
  variant = "primary",
  ...props
}) => {
  const [position, setPosition] = useState<PositionType[]>(["left", "right"]);

  return (
    <>
      <AntdTabs
        items={items}
        className={cn(styles.tabs, styles[`tabs__${variant}`])}
        {...props}
      />
    </>
  );
};

export default Tabs;
